<aside class="left-sidebar hidden-sm-down">
    <div class="scroll-sidebar ps ps--theme_default ps--active-y">
        <nav class="sidebar-nav">
            <ul id="sidebarnav" class="sidebar-ul">
                <ng-container *ngFor="let item of menuItems">
                    <li class="sidebar-li" *ngIf="item.hasAccess" [class.hover-active]="item.name === activeMenuItem"
                        (mouseenter)="showSubmenu(item)" (mouseleave)="hideSubmenu(item)">
                        <a class="nav-item">
                            <img [src]="item.icon" class="menu-item" />
                            <p class="sidebar-text">{{ item.name }}</p>
                        </a>
                        <div class="submenu-container" *ngIf="item.showSubmenu" (mouseenter)="stayOpen(item)"
                            (mouseleave)="hideSubmenu(item)">
                            <ul class="submenu-ul" *ngFor="let sub of item.submenuitem">
                                <li class="submenu-li" (click)="setActiveMenuItem(item.name, sub)"
                                    style="cursor: pointer;">
                                    <a class="nav-item submenu-title" [routerLink]="sub.link">{{ sub.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ng-container>
            </ul>
        </nav>
    </div>
</aside>
<aside class="left-sidebar-mobile hidden-md-up">
    <div class="scroll-sidebar ps ps--theme_default ps--active-y">
        <nav class="sidebar-nav">
            <ul id="sidebarnav" class="sidebar-ul">
                <li class="sidebar-li" *ngFor="let item of menuItems"
                    [class.hover-active]="item.name === activeMenuItem" (mouseenter)="showSubmenu(item)"
                    (mouseleave)="hideSubmenu(item)">
                    <a class="nav-item sidebar-text"><img [src]="item.icon" class="menu-item" />
                        <p class="sidebar-text">{{ item.name }}</p>
                    </a>
                    <!--submenu-->
                    <div class="submenu-container animated easeout" *ngIf="item.statussub && item.showSubmenu"
                        [class.submenu-active]="item.name === activeMenuItem" (mouseenter)="stayOpen(item)"
                        (mouseleave)="hideSubmenu(item)">
                        <!-- Submenu items -->
                        <ul class="submenu-ul" *ngFor="let sub of item.submenuitem">
                            <li class="submenu-li" (click)="setActiveMenuItem(item.name, sub)">
                                <a class="nav-item submenu-title">{{ sub.name }}</a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </nav>
    </div>
</aside>